import { assertNever } from '@kofno/piper';
import { just, Maybe, nothing } from 'maybeasy';
import ReactionComponent, { RCProps } from '../../ReactionComponent';
import ToastStore from './Store';
import { State, TOAST_DURATION_MS } from './Store/Types';

interface Props extends RCProps<ToastStore> {}

class ToastReactions extends ReactionComponent<ToastStore, State, Props> {
  // One pending expiry at a time: a newer toast or an unmount cancels it, so
  // no timer outlives the toast it belongs to.
  private timer: Maybe<number> = nothing();

  private clearTimer = () => {
    this.timer.do((handle) => window.clearTimeout(handle));
    this.timer = nothing();
  };

  tester = () => this.props.store.state;
  effect = (state: State) => {
    const { store } = this.props;
    this.clearTimer();
    switch (state.kind) {
      case 'hidden':
        break;
      case 'showing': {
        const { id } = state.toast;
        this.timer = just(window.setTimeout(() => store.expire(id), TOAST_DURATION_MS));
        break;
      }
      default:
        assertNever(state);
    }
  };

  componentWillUnmount() {
    this.clearTimer();
    super.componentWillUnmount();
  }
}

export default ToastReactions;
